/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAvailableFeaturesUserControllerPromoteMutationRequest,
  TelegramAvailableFeaturesUserControllerPromoteMutationResponse,
  TelegramAvailableFeaturesUserControllerPromote401,
} from '../types/TelegramAvailableFeaturesUserControllerPromote.ts';

function getTelegramAvailableFeaturesUserPromoteUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/available-features/promote` as const };
  return res;
}

/**
 * {@link /api/user/telegram/available-features/promote}
 */
export async function telegramAvailableFeaturesUserPromote(
  data: TelegramAvailableFeaturesUserControllerPromoteMutationRequest,
  config: Partial<RequestConfig<TelegramAvailableFeaturesUserControllerPromoteMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAvailableFeaturesUserControllerPromoteMutationResponse,
    ResponseErrorConfig<TelegramAvailableFeaturesUserControllerPromote401>,
    TelegramAvailableFeaturesUserControllerPromoteMutationRequest
  >({
    method: 'POST',
    url: getTelegramAvailableFeaturesUserPromoteUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
